import { render } from "./TriggerCard.vue?vue&type=template&id=67bf3930&scoped=true&ts=true"
import script from "./TriggerCard.vue?vue&type=script&lang=ts"
export * from "./TriggerCard.vue?vue&type=script&lang=ts"

import "./TriggerCard.vue?vue&type=style&index=0&id=67bf3930&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67bf3930"]])

export default __exports__